<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 15:57:42
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-14 18:15:59
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/chart-bar.vue
 * @Description: 堆叠柱状图
-->
<template>
  <div id="chart-bar" v-loading="loading.ccy"></div>
</template>

<script>
import { Chart } from '@antv/g2'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      chart: null
    }
  },
  computed: {
    ...mapState('company-profile', ['ccy', 'loading'])
  },
  watch: {
    'loading.ccy' () {
      this.initChart()
    }
  },
  methods: {
    initChart () {
      this.chart = new Chart({
        container: 'chart-bar',
        autoFit: true
      })
      this.chart.data(this.ccy.sc_trend)
      this.chart.scale('percent', {
        min: 0, max: 100
      })
      this.chart.scale('total', {
        min: 0, max: 20000, alias: '产业总值'
      })
      this.chart.axis('percent', {
        position: 'right',
        tickCount: 5,
        label: {
          style: {
            fill: '#FFFFFF'
          }
        },
        grid: {
          line: {
            style: {
              stroke: '#d9d9d9',
              lineWidth: 1,
              lineDash: [1, 1]
            }
          }
        },
        title: {
          text: '百分比(%)',
          autoRotate: true,
          position: 'center',
          // offset: 10,
          // spacing: 10,
          style: {
            fill: '#FFFFFF'
          }
        }
      })
      this.chart.axis('total', {
        position: 'left',
        tickCount: 5,
        label: {
          style: {
            fill: '#FFFFFF'
          }
        },
        grid: {
          line: {
            style: {
              stroke: '#d9d9d9',
              lineWidth: 1,
              lineDash: [1, 1]
            }
          }
        },
        title: {
          text: '产业总值(万元)',
          autoRotate: true,
          position: 'center',
          style: {
            fill: '#FFFFFF'
          }
        }
      })
      this.chart.axis('year', {
        position: 'bottom',
        label: {
          style: {
            fill: '#FFFFFF'
          }
        }
      })
      this.chart.legend({
        position: 'top',
        itemName: {
          style: {
            fill: '#FFFFFF'
          }
        }
      })

      this.chart.interval()
        .position('year*percent')
        .color('name', ['#E47B6A', '#F5C41B', '#10F5B1'])
        .size(8)
        .adjust([
          {
            type: 'dodge',
            marginRatio: 0
          }
        ])
        .style({
          stroke: null
        })
      this.chart.line()
        .position('year*total')
        .color('#6DF9FF')
      this.chart.area()
        .position('year*total')
        .color('#6DF9FF')
      this.chart.render()
    }
  }
}
</script>
